import React, { useState } from 'react';
import { motion } from 'framer-motion';
import _ from 'lodash';
import BoxedContainer from './layouts/BoxedContainer';

export default function FreeZoneBrowseLicenseType({ data, id }) {
  const { title, text, items } = data;
  const [clickedIndex, setClickedIndex] = useState(null);
  return (
    <section id={id} className="pt-[50px] lg:pt-[100px] pb-[170px] md:pb-[165px] bg-[#F7F7F7]">
      <BoxedContainer>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col gap-y-6 lg:gap-y-[30px]">
          <div className="flex flex-col gap-y-5">
            <div
              dangerouslySetInnerHTML={{ __html: title }}
              className="text-clamp20to40  h2-child:text-clamp20to40 text-[#4A4A4A]
            h2-child:leading-1.2 h2-child:!m-0 text-center"
            />
            <div className="h-[2px] w-[70px] bg-[#CE445B] mx-auto" />
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className="p-child:text-[#4A4A4A] p-child:text-clamp12to18 p-child:font-normal
            p-child:leading-[1.6] p-child:mb-0 p-child:ltr:font-URWDINRegular p-child:rtl:font-GESSTwoDWTCLight text-center"
          />
        </motion.div>
        {_.isEmpty(items) || (
          <div
            className="pt-10 md:flex flex-wrap gap-4 md:gap-[30px]
          justify-center hidden">
            {_.map(items, (item, index) => (
              <div
                key={index}
                className="h-[270px] relative group overflow-hidden w-[calc(50%-10px)]
                md:w-[calc(25%-23px)]">
                {_.isEmpty(item.content.image) || (
                  <img
                    src={item.content.image.url}
                    alt={item.content.itemTitle}
                    className="!w-full !h-full object-cover !absolute !z-5 group-hover:scale-110
                    transition-all duration-200"
                  />
                )}
                <div
                  className="flex flex-col gap-y-[15px] w-full h-full relative
             items-center transition-all duration-200 justify-center">
                  <div
                    className="absolute w-full h-full before:content-[''] before:absolute
               before:top-0 before:w-full before:h-full before:bg-[#1a1a1a]
               before:bg-opacity-60 before:z-[5] before:!inline
               transition-all duration-200 before:group-hover:!bg-[#CE445B]
               before:transition-all before:duration-200"
                  />
                  <div
                    className="relative z-10 flex flex-col gap-y-[10px] lg:gap-y-[15px] items-center 
                  overflow-auto py-5">
                    {_.isEmpty(item.content.iconImage) || (
                      <img
                        src={item.content.iconImage.url}
                        alt={item.content.itemTitle}
                        className="w-[25px] h-[25px]"
                      />
                    )}
                    <div
                      className="flex flex-col lg:gap-y-[15px] gap-y-[10px] mx-auto
               text-center z-10 px-4">
                      <h3
                        className="text-white text-[16px] lg:text-[20px]
                      !font-DINRegular font-medium mb-0 transition-all duration-200">
                        {item.content.itemTitle}
                      </h3>
                      <div
                        className="p-child:text-white p-child:text-[12px] p-child:lg:text-[15px]
                        p-child:font-URWDINRegular p-child:leading-[18px]  p-child:mb-3 
                        hidden group-hover:md:!block transition-all duration-200"
                        dangerouslySetInnerHTML={{ __html: item.content.itemText }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        {_.isEmpty(items) || (
          <div
            className="pt-10 flex flex-wrap gap-4 md:gap-x-[30px] md:gap-y-[50px]
          justify-center md:hidden">
            {_.map(items, (item, index) => (
              <button
                key={index}
                className={`h-[127px] relative group overflow-hidden
                ${clickedIndex === index 
                  ? `${clickedIndex % 2 !== 0 
                    ? `order-${index-2}` 
                    : `order-${index}`} 
                  w-full !h-[270px]` 
                  : `order-${index} w-[calc(50%-10px)]`}`}
                type="button"
                onClick={() => setClickedIndex(index)}>
                {_.isEmpty(item.content.image) || (
                  <img
                    src={item.content.image.url}
                    alt={item.content.itemTitle}
                    className="!w-full !h-full object-cover !absolute !z-5 group-hover:scale-110
                    transition-all duration-200"
                  />
                )}
                <div
                  className="flex flex-col gap-y-[15px] w-full h-full relative
                  items-center transition-all duration-200 justify-center">
                  <div
                    className="absolute w-full h-full before:content-[''] before:absolute
                    before:top-0 before:w-full before:h-full before:bg-[#1a1a1a]
                    before:bg-opacity-60 before:z-[5] before:!inline
                    transition-all duration-200 before:group-hover:!bg-[#CE445B]
                    before:transition-all before:duration-200 before:right-0"
                  />
                  <div
                    className="relative z-10 flex flex-col gap-y-[10px] lg:gap-y-[15px] items-center
                  overflow-auto py-5">
                    {_.isEmpty(item.content.iconImage) || (
                      <img
                        src={item.content.iconImage.url}
                        alt={item.content.itemTitle}
                        className="w-[25px] h-[25px]"
                      />
                    )}
                    <div
                      className="flex flex-col gap-y-[10px] mx-auto
                      text-center z-10 px-4">
                      <h3
                        className="text-white text-[16px]
                      !font-DINRegular font-medium mb-0 transition-all duration-200 leading-[100%]">
                        {item.content.itemTitle}
                      </h3>
                      <div
                        className={`p-child:text-white p-child:text-[12px]
                        p-child:font-URWDINRegular p-child:leading-[18px] p-child:mb-3 hidden
                        group-hover:md:!block transition-all duration-200
                        ${clickedIndex === index ? 'opacity-100 !block' : 'opacity-0'}`}
                        dangerouslySetInnerHTML={{ __html: item.content.itemText }}
                      />
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        )}
      </BoxedContainer>
    </section>
  );
}
